export default {
  nav_home: 'Home',
  nav_guides: 'Guides',
  nav_shipping: 'Shipping',
  nav_qc: 'QC',
  nav_warehouse: 'Warehouse',
  nav_coupon: 'Coupons',
  nav_language: 'Language',
  nav_about: 'About',
  nav_contact: 'Contact',
  hero_title: 'CSSBuy Spreadsheet: Guides, Links and Updated Resources',
  hero_subtitle: 'Explore CSSBuy Spreadsheet resources, QC, shipping, warehouse, reviews and comparisons all in one place.',
  hero_cta_explore: 'Explore CSSBuy Spreadsheet',
  hero_cta_guide: 'View Beginner Guide',
  badge_independent: 'Independent',
  badge_updated: 'Updated',
  badge_transparent: 'Transparent',
  categories_title: 'Popular Categories',
  categories_select: 'Select Category',
  categories_browse: 'Browse Categories',
  what_is_title: 'What is CSSBuy Spreadsheet',
  what_is_desc: 'CSSBuy Spreadsheet is an essential tool for buyers using the CSSBuy agent to purchase products from Chinese platforms like Taobao, Weidian and 1688. The spreadsheet organizes product links, prices, QC images and shipping status in an easy-to-navigate format. Our hub centralizes the best CSSBuy Spreadsheet resources, keeping everything updated for 2026.',
  guides_title: 'Featured Guides',
  review_title: 'CSSBuy Review',
  review_desc: 'Complete and independent review of the CSSBuy agent. We evaluate QC, shipping costs, service fees, customer support and user experience. Read our honest review before you start buying.',
  shipping_title: 'CSSBuy Shipping Cost',
  shipping_desc: 'Calculate and compare international shipping costs from CSSBuy. Learn about different shipping lines available, delivery times and tips to save on shipping to Brazil, USA, Europe and other destinations.',
  warehouse_title: 'CSSBuy Warehouse',
  warehouse_desc: 'Understand how CSSBuy warehouse storage works. Discover free storage periods, consolidation fees, packaging services and how to manage your purchase inventory.',
  coupon_title: 'Coupons and Discount Codes',
  coupon_desc: 'Find the latest CSSBuy coupons and discount codes. Save on service fees and shipping with our promotions updated regularly for new and existing users.',
  comparison_title: 'Agent Comparison',
  safety_title: 'Safety and Trust',
  safety_desc: 'Learn to shop safely using CSSBuy. Our safety guide covers product verification, payment protection, avoiding scams and how to verify item authenticity.',
  faq_title: 'Frequently Asked Questions',
  faq_q1: 'What is CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet is an organized collection of product links, prices and QC information for buyers using the CSSBuy agent. It is an essential tool for finding the best products quickly.',
  faq_q2: 'Is CSSBuy legit?',
  faq_a2: 'Yes, CSSBuy is an established shopping agent with years of operation. We always recommend checking recent reviews and using QC services to ensure product quality.',
  faq_q3: 'How to use CSSBuy Spreadsheet?',
  faq_a3: 'Browse product categories, click links to see details, add items to your CSSBuy cart and complete the purchase. The spreadsheet organizes everything to facilitate your experience.',
  faq_q4: 'What shipping methods does CSSBuy offer?',
  faq_a4: 'CSSBuy offers various shipping lines including EMS, DHL, EUB, SAL, and region-specific lines. Delivery times and costs vary depending on destination and package weight.',
  faq_q5: 'How does CSSBuy warehouse work?',
  faq_a5: 'CSSBuy warehouse receives your products from sellers, performs quality inspection (QC), stores items for up to 180 days free and consolidates multiple orders into a single shipment.',
  cta_main_title: 'Ready to start with CSSBuy?',
  cta_main_desc: 'Explore our resources and start shopping with confidence.',
  cta_main_button: 'Visit Main Website',
  cta_main_button2: 'Explore Spreadsheet',
  articles_title: 'Articles and Guides',
  articles_read_more: 'Read Full Article',
  articles_view_all: 'View All Articles',
  footer_about: 'About',
  footer_guides: 'Guides',
  footer_resources: 'Resources',
  footer_contact: 'Contact',
  footer_policy: 'Editorial Policy',
  footer_disclaimer: 'This website is an independent informational resource and is not affiliated with CSSBuy.',
  footer_copyright: 'cssbuybr.wiki - All rights reserved.',
  meta_home_title: 'CSSBuy Spreadsheet 2026: Guides, Links and Updated Resources',
  meta_home_desc: 'Explore CSSBuy Spreadsheet resources, QC, shipping, warehouse, reviews and comparisons. Updated guides for 2026.',
  article_spreadsheet_guide_title: 'Complete CSSBuy Spreadsheet Guide 2026',
  article_spreadsheet_guide_desc: 'The definitive guide to mastering CSSBuy Spreadsheet. Learn to find products, verify QC, compare prices and ship worldwide.',
  article_spreadsheet_guide_content: 'CSSBuy Spreadsheet has become one of the most sought-after tools for international buyers who want to purchase products from Chinese platforms like Taobao, Weidian and 1688. This complete guide for 2026 covers everything you need to know to make the most of this powerful tool.',
  article_review_title: 'CSSBuy Review 2026: Complete Analysis',
  article_review_desc: 'Independent and honest review of the CSSBuy agent. Detailed evaluation of QC, shipping, fees and support.',
  article_shipping_title: 'CSSBuy Shipping Guide 2026',
  article_shipping_desc: 'Cost calculation, shipping methods, delivery times and tips to save on international shipping.',
  article_warehouse_title: 'CSSBuy Warehouse Guide',
  article_warehouse_desc: 'How storage works, consolidation, timeframes and fees at the CSSBuy warehouse.',
  article_qc_title: 'CSSBuy QC Guide',
  article_qc_desc: 'Understand how CSSBuy Quality Check works and how to use QC photos to verify your products.',
  article_coupon_title: 'CSSBuy Coupons and Discount Codes',
  article_coupon_desc: 'Updated list of CSSBuy coupons, discount codes and active promotions for 2026.',
  back_to_home: 'Back to Home',
  last_updated: 'Last updated',
  related_articles: 'Related Articles',
  table_feature: 'Feature',
  table_cssbuy: 'CSSBuy',
  table_superbuy: 'Superbuy',
  table_sugargoo: 'Sugargoo',
  table_basetao: 'Basetao',
  table_research: 'Research',
  table_qc: 'QC',
  table_shipping: 'Shipping',
  table_ease: 'Ease of Use',
  table_fees: 'Fees',
  table_bestfor: 'Best For',
  nav_shopping_guide: 'Shopping Guide',
  article_discount_code_title: 'CSSBuy Discount Code Guide 2026',
  article_discount_code_desc: 'Find verified CSSBuy discount codes, active coupons and promotions to save on service fees and shipping in 2026.',
  article_legit_title: 'Is CSSBuy Legit? Honest 2026 Analysis',
  article_legit_desc: 'Detailed, honest analysis of CSSBuy trustworthiness, covering security, reputation, fees and buyer protection.',
  article_shipping_cost_title: 'CSSBuy Shipping Cost Guide 2026',
  article_shipping_cost_desc: 'Understand CSSBuy international shipping costs, compare lines and learn how to save on freight to Brazil, USA and Europe.',
  article_w2c_title: 'CSSBuy W2C Spreadsheet Guide 2026',
  article_w2c_desc: 'What W2C means, how to use W2C links in CSSBuy Spreadsheet and how to find the best products safely and quickly.',
  article_beginner_title: 'CSSBuy Beginner Guide 2026',
  article_beginner_desc: 'Complete beginner guide to buying with CSSBuy from scratch: signup, ordering, QC, shipping and essential tips.',
  article_comparison_title: 'CSSBuy vs Superbuy vs Sugargoo: 2026 Comparison',
  article_comparison_desc: 'Detailed comparison of CSSBuy, Superbuy and Sugargoo: fees, QC, shipping, ease of use and which agent to choose.',
  article_spreadsheet_links_title: 'CSSBuy Spreadsheet Links & Resources 2026',
  article_spreadsheet_links_desc: 'Updated collection of CSSBuy Spreadsheet links, resources, communities and tools to find the best products.',
  article_warehouse_fees_title: 'CSSBuy Warehouse Fees Explained 2026',
  article_warehouse_fees_desc: 'Understand all CSSBuy warehouse fees: storage, consolidation, packaging and how to avoid extra costs.',
  lang_pt: 'Português',
  lang_en: 'English',
  lang_de: 'Deutsch',
};